<div class="modal-backdrop">
  <div class="modal-container">
    <div class="modal">

      <div class="modal-header">
        <div class="dialog-header-content">
          <div class="dialog-icon">
            <!-- Phosphor: Package duotone -->
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#4d8241" viewBox="0 0 256 256">
              <path d="M223.68,66.15,135.68,18a15.88,15.88,0,0,0-15.36,0l-88,48.17a16,16,0,0,0-8.32,14v95.64a16,16,0,0,0,8.32,14l88,48.17a15.88,15.88,0,0,0,15.36,0l88-48.17a16,16,0,0,0,8.32-14V80.18A16,16,0,0,0,223.68,66.15Z" opacity="0.2"/>
              <path d="M223.68,66.15,135.68,18a15.88,15.88,0,0,0-15.36,0l-88,48.17a16,16,0,0,0-8.32,14v95.64a16,16,0,0,0,8.32,14l88,48.17a15.88,15.88,0,0,0,15.36,0l88-48.17a16,16,0,0,0,8.32-14V80.18A16,16,0,0,0,223.68,66.15ZM128,32l80.35,44L128,120,47.65,76ZM40,90l80,43.78v85.79L40,175.82Zm96,129.57V133.82L216,90v85.78Z"/>
            </svg>
          </div>
          <h3 class="modal-title">Confirmar Seleção</h3>
        </div>
      </div>

      <mat-dialog-content class="modal-body">

        <div class="card card-white">
          <div class="card-header">
            <p class="card-title">{{ data.product.name }}</p>
          </div>
          <div class="card-body">

            <div class="price-block">
              @if (data.product.grossTotal === 0 && data.product.finalTotal === 0) {
                <span class="badge badge-success price-badge">Gratuito</span>
              }
              @if (data.product.grossTotal !== 0 && data.product.finalTotal === 0) {
                <div class="price-row">
                  <span class="price-original"><del>{{ formatCurrencyValueByMonth(data.product.grossTotal) }}</del></span>
                  <span class="badge badge-success price-badge">
                    Gratuito {{ data.product.discounts?.[0]?.description }}
                  </span>
                </div>
              }
              @if (data.product.finalTotal !== 0) {
                <span class="price-value">{{ formatCurrencyValueByMonth(data.product.finalTotal) }}</span>
              }
              @if ((data.product.grossTotal! - data.product.finalTotal!) > 0 && data.product.finalTotal !== 0) {
                <div class="price-row">
                  <span class="price-original"><del>{{ formatCurrencyValueByMonth(data.product.grossTotal) }}</del></span>
                  <span class="price-value">{{ formatCurrencyValueByMonth(data.product.finalTotal) }}</span>
                </div>
              }
              @if (data.product.grossTotal !== 0) {
                <p class="price-label">Plano anual de {{ data.product.grossTotal | currency:'BRL':'symbol':'1.2-2':'pt-BR' }} com pagamento mensal.</p>
              }
            </div>

            <p class="plan-description">{{ data.product.description }}</p>

          </div>
        </div>

        <div class="alert alert-info">
          <mat-icon>info</mat-icon>
          <span>Ao confirmar, você será direcionado para o preenchimento do seu perfil.</span>
        </div>

      </mat-dialog-content>

      <mat-dialog-actions class="modal-footer">
        <button class="btn btn-ghost" (click)="cancel()">Voltar</button>
        <button class="btn btn-primary" (click)="confirm()">
          Confirmar Seleção
        </button>
      </mat-dialog-actions>

    </div>
  </div>
</div>